// export default Header1;
import { NavLink } from "react-router-dom";
import { useState, useEffect, useCallback } from "react";
import ItodoImage from "../../elements/itodo-img";
import { loadScript } from "../../../globals/constants";

function Header1() {
  /* ===============================
     STATE MANAGEMENT
  ================================ */
  const [isActive, setIsActive] = useState(false);

  /* ===============================
     HANDLERS
  ================================ */
  const toggleNavClass = useCallback(() => {
    setIsActive((prev) => !prev);
  }, []);

  const closeMenu = useCallback(() => {
    setIsActive(false);
  }, []);

  /* ===============================
     LOAD MOBILE SCRIPT (ONCE)
  ================================ */
  useEffect(() => {
    loadScript("js/mobilenav.js");
  }, []);

  return (
    <header
      className={`header-style1 site-header mobile-sider-drawer-menu ${
        isActive ? "active" : ""
      }`}
    >
      {/* ================= TOP BAR ================= */}
      <div className="top-bar">
        <div className="container-fluid ps-3 ">
          <div className="d-flex justify-content-between  align-content-center">
            <div className="sx-topbar-left">
              <ul className="e-p-bx">
                <li>admin@darchtech.com</li>
                <li>
                  <a href="tel:+917558307059">
                    Call: +91 7558307059 / 9623922545
                  </a>
                </li>
              </ul>
            </div>

            <div className="sx-topbar-right">
              <div className="top-bar-nav">
                <ul>
                  <li>
                    <NavLink to="/about-us">Terms &amp; Condition</NavLink>
                  </li>
                  <li>|</li>
                  <li>
                    <NavLink to="/contact-us">Contact Us</NavLink>
                  </li>
                </ul>
                <div>
                  {/* SOCIAL ICONS */}
                  <div className="extra-nav h-25">
                    <ul className="list-unstyled social-bx flex-wrap align-content-end justify-content-end d-flex">
                      <li>
                        <a
                          href="https://www.facebook.com/share/1C9iU3qFcT/"
                          target="_blank"
                          rel="noreferrer"
                        >
                          <i className="feather-facebook" />
                        </a>
                      </li>
                      <li>
                        <a
                          href="https://www.linkedin.com/in/darch-tech-7b6535394?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app"
                          target="_blank"
                          rel="noreferrer"
                        >
                          <i className="feather-linkedin" />
                        </a>
                      </li>
                      <li>
                        <a
                          href="https://www.instagram.com/darch.tech?igsh=MWF3NzBjbjdhMzJvaA%3D%3D&utm_source=qr"
                          target="_blank"
                          rel="noreferrer"
                        >
                          <i className="feather-instagram" />
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* ================= MAIN HEADER ================= */}
      <div className="sticky-header main-bar-wraper navbar-expand-lg">
        <div className="main-bar">
          <div className="container clearfix">
            {/* LOGO */}
            <div className="logo-header">
              <NavLink to="/" onClick={closeMenu}>
                <ItodoImage src="images/Logo-light.png" alt="Company Logo" />
              </NavLink>
            </div>
            {/* MOBILE TOGGLE */}
            <button
              id="mobile-side-drawer"
              data-target=".header-nav"
              data-toggle="collapse"
              className="navbar-toggler collapsed absolute"
              onClick={toggleNavClass}
            >
              <span className="sr-only">Toggle navigation</span>
              <span className="icon-bar icon-bar-first" />
              <span className="icon-bar icon-bar-two" />
              <span className="icon-bar icon-bar-three" />
            </button>

            {/* ================= NAVIGATION ================= */}
            <div className="header-nav navbar-collapse collapse d-flex justify-content-center">
              <ul className="nav navbar-nav" onClick={closeMenu}>
                <li>
                  <NavLink to="/">Home</NavLink>
                </li>

                <li>
                  <NavLink to="/about-us">Company</NavLink>
                  <ul className="sub-menu">
                    <li>
                      <NavLink to="/about-us">About Us</NavLink>
                    </li>
                    <li>
                      <NavLink to="/pricing">Pricing</NavLink>
                    </li>
                  </ul>
                </li>

                <li>
                  <NavLink to="/services">IT Services</NavLink>
                  <ul className="sub-menu">
                    <li>
                      <NavLink to="/services/web-development/">
                        Web Services
                      </NavLink>
                    </li>
                    <li>
                      <NavLink to="/services/mobile-app-development">
                        Mobile Services
                      </NavLink>
                    </li>
                    <li>
                      <NavLink to="/services/digital-marketing">
                        Digital Marketing Services
                      </NavLink>
                    </li>
                  </ul>
                </li>

                <li>
                  <NavLink to="/contact-us">Contact Us</NavLink>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
}

export default Header1;
